/* tslint:disable: jsx-boolean-value */
import ShopifyConnect from './ShopifyConnect';
import withPadding from 'components/core/withPadding';
import withLabel from 'components/core/withLabel';


export default withPadding(withLabel(ShopifyConnect));
